/* @flow */
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import Layer from 'components/Layer.jsx';
import React from 'react';

import cx from 'classnames';
import './styles/Tooltip.scss';

/**
 * Tooltip used throughout the application.
 *
 * # Placement
 *
 * ```example
 *  <div style={{padding: 100}}>
 *    <LayerTrigger layer={<Tooltip>Remind</Tooltip>} placement="top">
 *      <Glyph name="remind-icon" size="xlarge" />
 *    </LayerTrigger>
 *    <LayerTrigger layer={<Tooltip>Home</Tooltip>} placement="left">
 *      <Glyph name="home" size="xlarge" />
 *    </LayerTrigger>
 *    <LayerTrigger layer={<Tooltip>Chat</Tooltip>} placement="right">
 *      <Glyph name="chat" size="xlarge" />
 *    </LayerTrigger>
 *    <LayerTrigger layer={<Tooltip>Settings</Tooltip>} placement="bottom">
 *      <Glyph name="gear" size="xlarge" />
 *    </LayerTrigger>
 *  </div>
 * ```
 *
 * # Alignment
 *
 * ```example
 *  <div style={{padding: 100}}>
 *    <Link
 *      tooltip="Home"
 *      tooltipPlacement="top"
 *      tooltipAlignment="left"
 *      style={{display: 'inline-block'}}>
 *      <Glyph name="home" size="xlarge" />
 *    </Link>
 *    <Link
 *      tooltip="Chat"
 *      tooltipPlacement="top"
 *      tooltipAlignment="middle"
 *      style={{display: 'inline-block'}}>
 *      <Glyph name="chat" size="xlarge" />
 *    </Link>
 *    <Link
 *      tooltip="Settings"
 *      tooltipPlacement="top"
 *      tooltipAlignment="right"
 *      style={{display: 'inline-block'}}>
 *      <Glyph name="gear" size="xlarge" />
 *    </Link>
 *    <br />
 *    <Link
 *      tooltip="Home"
 *      tooltipPlacement="bottom"
 *      tooltipAlignment="left"
 *      style={{display: 'inline-block'}}>
 *      <Glyph name="home" size="xlarge" />
 *    </Link>
 *    <Link
 *      tooltip="Chat"
 *      tooltipPlacement="bottom"
 *      tooltipAlignment="middle"
 *      style={{display: 'inline-block'}}>
 *      <Glyph name="chat" size="xlarge" />
 *    </Link>
 *    <Link
 *      tooltip="Settings"
 *      tooltipPlacement="bottom"
 *      tooltipAlignment="right"
 *      style={{display: 'inline-block'}}>
 *      <Glyph name="gear" size="xlarge" />
 *    </Link>
 *    <br />
 *    <Link
 *      tooltip={<span>Home<br/ >Home</span>}
 *      tooltipPlacement="left"
 *      tooltipAlignment="top"
 *      style={{display: 'inline-block'}}>
 *      <Glyph name="home" size="xlarge" />
 *    </Link>
 *    <Link
 *      tooltip={<span>Chat<br/ >Chat</span>}
 *      tooltipPlacement="left"
 *      tooltipAlignment="middle"
 *      style={{display: 'inline-block'}}>
 *      <Glyph name="chat" size="xlarge" />
 *    </Link>
 *    <Link
 *      tooltip={<span>Settings<br/ >Settings</span>}
 *      tooltipPlacement="left"
 *      tooltipAlignment="bottom"
 *      style={{display: 'inline-block'}}>
 *      <Glyph name="gear" size="xlarge" />
 *    </Link>
 *    <br />
 *    <Link
 *      tooltip={<span>Home<br/ >Home</span>}
 *      tooltipPlacement="right"
 *      tooltipAlignment="top"
 *      style={{display: 'inline-block'}}>
 *      <Glyph name="home" size="xlarge" />
 *    </Link>
 *    <Link
 *      tooltip={<span>Chat<br/ >Chat</span>}
 *      tooltipPlacement="right"
 *      tooltipAlignment="middle"
 *      style={{display: 'inline-block'}}>
 *      <Glyph name="chat" size="xlarge" />
 *    </Link>
 *    <Link
 *      tooltip={<span>Settings<br/ >Settings</span>}
 *      tooltipPlacement="right"
 *      tooltipAlignment="bottom"
 *      style={{display: 'inline-block'}}>
 *      <Glyph name="gear" size="xlarge" />
 *    </Link>
 *  </div>
 * ```
 */

class Tooltip extends React.Component {
  static propTypes = {
    ...Layer.propTypes,
    color: React.PropTypes.oneOf(['default', 'shamrock', 'violet', 'lava', 'flame']),
    type: React.PropTypes.oneOf(['normal', 'nux']),
    header: React.PropTypes.string,
  };

  static propClasses = {
    color: {
      shamrock: 'Tooltip-shamrock',
      violet: 'Tooltip-violet',
      lava: 'Tooltip-lava',
      flame: 'Tooltip-flame',
    },
    type: {
      nux: 'Tooltip-nux',
    },
  };

  static defaultProps = {
    type: 'normal',
  };

  render() {
    return (
      <Layer
        {...this.props}
        className={cx('Tooltip', getPropClassesFromInstance(this), this.props.className)}>
        {this.props.header && <div className="Tooltip-header">{this.props.header}</div>}
        {this.props.children}
      </Layer>
    );
  }
}

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/Tooltip.jsx